<template>
  <section id="ourclient" class="section partners">
    <div class="section-container reveal">
      <div class="section-head partners-head">
        <div>
          <span class="section-label">Dipercaya Oleh</span>
          <h2 class="section-title">Klien Kami</h2>
        </div>
        <p class="section-copy">
          Brand dan institusi yang telah mempercayakan kebutuhan digitalnya
          kepada tim Abercode.
        </p>
      </div>

      <div class="partner-grid">
        <article v-for="partner in partners" :key="partner.alt" class="partner-card card">
          <img :src="partner.logo" :alt="partner.alt" loading="lazy" decoding="async" />
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import clientOne from "@/assets/client 1.png";
import clientTwo from "@/assets/client 2.png";
import clientThree from "@/assets/client 3.png";
import clientFour from "@/assets/client 4.png";
import clientFive from "@/assets/client 5.png";

export default {
  name: "PartnersClient",
  data() {
    return {
      partners: [
        { logo: clientOne, alt: "Client 1" },
        { logo: clientTwo, alt: "Client 2" },
        { logo: clientThree, alt: "Client 3" },
        { logo: clientFour, alt: "Client 4" },
        { logo: clientFive, alt: "Client 5" },
      ],
    };
  },
};
</script>

<style scoped>
.partners {
  padding-top: 28px;
}

.partners-head {
  align-items: center;
}

.partner-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
}

.partner-card {
  flex: 0 1 calc((100% - 48px) / 5);
  min-width: 0;
  min-height: 126px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px;
  background: linear-gradient(145deg, #fff, #f5f8ff);
}

.partner-card img {
  max-height: 64px;
  width: auto;
  object-fit: contain;
  filter: saturate(0.88) contrast(1.05);
  transition: transform 0.22s ease, filter 0.22s ease;
}

.partner-card:hover img {
  transform: translateY(-2px) scale(1.03);
  filter: saturate(1) contrast(1);
}

@media (max-width: 920px) {
  .partner-card {
    flex-basis: calc((100% - 24px) / 3);
  }
}

@media (max-width: 640px) {
  .partner-grid {
    gap: 10px;
  }

  .partner-card {
    flex-basis: calc((100% - 20px) / 3);
  }

  .partner-card {
    min-height: 88px;
    padding: 10px;
  }

  .partner-card img {
    max-height: 42px;
  }
}

@media (max-width: 390px) {
  .partner-card {
    flex-basis: calc((100% - 10px) / 2);
  }
}
</style>
